module.exports = "/_next/static/images/e3c174e16e1bb140997156bdc137fb3e-debit-card-magic.png";